import type { DataTableColumnOrderSettingsProps } from './column-settings-types.js';

/**
 * The slot component serves the sole purpose of detecting the user's intention
 * to display column order within the column settings modal, situated in the DataTable toolbar.
 * @public
 */
export const DataTableColumnOrderSettings = ({
  resetColumnOrder,
}: DataTableColumnOrderSettingsProps) => null;

DataTableColumnOrderSettings.displayName = 'DataTable.ColumnOrderSettings';
